export default __webpack_public_path__ + "game39d63a.jpg";